import React, { useState, useEffect } from "react";
import { DocCard } from "../../../misc/types";
import DocumentCard from "../DocumentCard/DocumentCard";
import arrowUp from "../../../assets/svg/arrow-gray-up.svg";
import arrowDown from "../../../assets/svg/arrow-gray-down.svg";
import { SocialTranscriptItem } from "../../../types";
import Modal from "../../Modal/Modal";
import {
  accessGlobalMiscState,
  useGlobalMiscState,
} from "../../../stores/misc";
import {
  onInputChangeNative,
  showSnackbar,
  updateLocalStateRaw,
  updateMiscState,
} from "../../../misc/utils";
import InputField from "../../input-field/InputField";
import { useHookstate } from "@hookstate/core";
import DefaultButton from "../../default-button/DefaultButton";
import ArrowLeft from "../../../assets/icons/ArrowLeft";
import Tick from "../../../assets/icons/Tick";
import Cross from "../../../assets/icons/Cross";
import { simpleGetter } from "../../../actions/common";
import { socialTranscriptApi } from "../../../api/api";

type Props = {
  searchQuery: string;
  documents: SocialTranscriptItem[];
  onDelete: (id: number) => void;
};

function SortBtn({
  isSorted,
  sortOrder,
}: {
  isSorted: boolean;
  sortOrder: "asc" | "desc" | null;
}) {
  return (
    <div className='flex flex-col gap-1'>
      <img
        className={`h-2 ${
          isSorted && sortOrder === "asc" ? "opacity-100" : "opacity-50"
        }`}
        src={arrowUp}
        alt='Sort Ascending'
      />
      <img
        className={`h-2 ${
          isSorted && sortOrder === "desc" ? "opacity-100" : "opacity-50"
        }`}
        src={arrowDown}
        alt='Sort Descending'
      />
    </div>
  );
}

export default function DocumentTable({
  searchQuery,
  documents,
  onDelete,
}: Props) {
  const localState = useHookstate({});
  const state: Record<string, any> = localState.get();
  const rejectReason = state.rejectReason || "";
  const miscState = useGlobalMiscState();
  const socialTranscriptRejectMode = miscState.get(
    "socialTranscriptRejectMode"
  );
  const isSocialTranscriptItemModalVisible = Boolean(
    miscState.get("isSocialTranscriptItemModalVisible")
  );
  const [sortOrder, setSortOrder] = useState<"asc" | "desc" | null>(null);
  const [currentSortCategory, setCurrentSortCategory] = useState<string>("");

  // useEffect(() => {
  //   const filtered = documents.filter((doc) =>
  //     doc.name.toLowerCase().includes(searchQuery.toLowerCase())
  //   );
  //   setFilteredDocuments(filtered);
  // }, [documents, searchQuery]);

  const handleSort = (category: string) => {
    // const newSortOrder =
    //   currentSortCategory === category && sortOrder === "asc" ? "desc" : "asc";
    // setSortOrder(newSortOrder);
    // setCurrentSortCategory(category);
    // const sortedDocs = [...filteredDocuments].sort((a, b) => {
    //   switch (category) {
    //     case "Студент":
    //       return newSortOrder === "asc"
    //         ? a.name.localeCompare(b.name)
    //         : b.name.localeCompare(a.name);
    //     case "Категория":
    //       return newSortOrder === "asc"
    //         ? a.category.localeCompare(b.category)
    //         : b.category.localeCompare(a.category);
    //     case "Пункт":
    //       return newSortOrder === "asc"
    //         ? a.item.localeCompare(b.item)
    //         : b.item.localeCompare(a.item);
    //     case "Дата загрузки":
    //       const dateA = new Date(a.uploadTime);
    //       const dateB = new Date(b.uploadTime);
    //       return newSortOrder === "asc"
    //         ? dateA.getTime() - dateB.getTime()
    //         : dateB.getTime() - dateA.getTime();
    //     default:
    //       return 0;
    //   }
    // });
    // setFilteredDocuments(sortedDocs);
  };

  const closeModal = () => {
    miscState.set("isSocialTranscriptItemModalVisible", false);
  };

  const submitRejection = async () => {
    const requestBody = {
      model: "SocialTranscriptItem",
      body: {
        filters: {
          id: miscState.get("socialTranscriptRejectDoc")?.id,
        },
        update: {
          status: -1,
        },
        additional_data: {
          reject_reason: rejectReason,
        },
      },
    };
    const response = await simpleGetter(
      socialTranscriptApi.updateModel,
      requestBody
    );
    showSnackbar(
      response.success ? "Успешно" : "Произошла ошибка",
      response.success ? "success" : "error"
    );
    if (response.success) {
      closeModal();
      accessGlobalMiscState().set(
        "socialTranscriptItemsTriggerFetch",
        (accessGlobalMiscState().get("socialTranscriptItemsTriggerFetch") ||
          0) + 1
      );
    }
  };

  const columns = [
    { title: "Студент", key: "student", minWidth: 180 },
    { title: "Категория", key: "category", minWidth: 140 },
    { title: "Пункт", key: "subcategory", minWidth: 140 },
    { title: "Дата загрузки", key: "date", minWidth: 130 },
    { title: "Дата ивента", key: "event_date", minWidth: 130 },
    { title: "Описание", key: "description", minWidth: 160 },
    { title: "Ссылка", key: "link", minWidth: 90 },
    { title: "Документ", key: "document", minWidth: 240 },
    { title: "", key: "actions", minWidth: 130 },
  ];

  return (
    <div className='bg-[white] rounded-xl p-2 text-[#5F6B88] font-medium text-sm'>
      <div className='overflow-x-auto'>
        <table className='w-full min-w-[1340px] table-fixed border-collapse'>
          <colgroup>
            {columns.map((c) => (
              <col key={c.key} style={{ width: `${c.minWidth}px` }} />
            ))}
          </colgroup>
          <thead>
            <tr>
              {columns.map(({ title, key }) => (
                <th
                  key={key}
                  className='px-2 py-2 text-left cursor-pointer font-medium text-[#5F6B88]'
                  onClick={() => handleSort(key)}
                >
                  <div className='flex items-center gap-2 min-w-0'>
                    <span className='truncate'>{title}</span>
                    {title && (
                      <SortBtn
                        isSorted={currentSortCategory === key}
                        sortOrder={sortOrder}
                      />
                    )}
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {documents.map((doc) => (
              <DocumentCard key={doc.id} doc={doc} />
            ))}
          </tbody>
        </table>
      </div>
      <Modal
        visible={isSocialTranscriptItemModalVisible}
        setVisible={updateMiscState("isSocialTranscriptItemModalVisible")}
        additionalClassName='p-8 w-[32.5%]'
      >
        <div className='flex flex-col gap-8'>
          <span className='text-2xl leading-[26.4px] text-valley-black'>
            Отказ
          </span>
          <InputField
            type='textarea'
            id='social-transcript-item-reject-reason'
            label='Укажите причину отказа'
            handleChange={onInputChangeNative(localState, "rejectReason")}
            value={rejectReason}
            additionalClassName='bg-valley-background-blue py-3 px-4 rounded-lg'
            disabled={socialTranscriptRejectMode === "display"}
          />
          {socialTranscriptRejectMode === "update" && (
            <div className='flex-1 flex flex-row gap-3'>
              <DefaultButton
                buttonText='Вернуться'
                additionalStyle='flex-1 bg-[#5F6B88] text-white px-8 py-3 text-nowrap'
                Icon={ArrowLeft}
                onClick={closeModal}
              />
              <DefaultButton
                buttonText='Отказать'
                additionalStyle='flex-1 bg-valley-red text-white px-8 py-3 text-nowrap'
                Icon={Cross}
                onClick={submitRejection}
                disabled={!rejectReason.length}
              />
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
}
